const MODULE = 'TEXTS';

export const GET_TEXTS = `${MODULE}_GET_TEXTS`;
